import * as React from 'react';
import 'react-datepicker/dist/react-datepicker-cssmodules.min.css';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { IEmptyProps } from './constants';
import AdminAccountingDetails from './views/adminAccountingDetails/AdminAccountingDetails';
import AdminAllAccounting from './views/adminAllAccounting/AdminAllAccounting';
import AdminAllBooking from './views/adminAllBooking/AdminAllBooking';
import AdminAllCourseProvider from './views/adminAllCourseProvider/AdminAllCourseProvider';
import AdminAllCourses from './views/adminAllCourses/AdminAllCourses';
import AdminBaseData from './views/adminBaseData/AdminBaseData';
import AdminDashboard from './views/adminDashboard/AdminDashboard';
import CPAllCourses from './views/cpAllCourses/CPAllCourses';
import CPAllLecturers from './views/cPAllLecturers/CPAllLecturers';
import CPAllLocations from './views/cPAllLocations/CPAllLocations';
import CPBookings from './views/cpBookings/CPBookings';
import CPCourse from './views/cpCourse/CPCourse';
import CPProfile from './views/cpProfile/CPProfile';
import ForgotPassword from './views/forgotPassword/ForgotPassword';
import ForgotPasswordResult from './views/forgotPasswordResult/ForgotPasswordResult';
import LogIn from './views/login/LogIn';
import Logout from './views/logout/Logout';
import NewPassword from './views/newPassword/NewPassword';
import NewPasswordFailed from './views/newPasswordFailed/NewPasswordFailed';
import NewPasswordSuccess from './views/newPasswordSucces/NewPasswordSuccess';
import Registration from './views/registration/Registration';
import RegistrationActivation from './views/registrationActivation/RegistrationActivation';
import RegistrationResult from './views/registrationResult/RegistrationResult';

interface IAppState {
    unsavedChanges: boolean;
}

export default class App extends React.PureComponent<IEmptyProps, IAppState> {
    public render() {
        return (
            <HashRouter>
                <Switch>
                    <Route exact={true} path="/" component={LogIn} />
                    <Route exact={true} path="/registration" component={Registration} />
                    <Route exact={true} path="/registrationResult/:token" component={RegistrationResult} />
                    <Route exact={true} path="/registrationActivation" component={RegistrationActivation} />
                    <Route exact={true} path="/forgotPassword" component={ForgotPassword} />
                    <Route exact={true} path="/forgotPasswordResult" component={ForgotPasswordResult} />
                    <Route exact={true} path="/newPassword/:token" component={NewPassword} />
                    <Route exact={true} path="/newPasswordSuccess" component={NewPasswordSuccess} />
                    <Route exact={true} path="/newPasswordFailed" component={NewPasswordFailed} />
                    <Route exact={true} path="/logout" component={Logout} />
                    <Route exact={true} path="/baseData" component={AdminBaseData} />
                    <Route exact={true} path="/dashboard" component={AdminDashboard} />
                    <Route exact={true} path="/bookings" component={AdminAllBooking} />
                    <Route exact={true} path="/courses" component={AdminAllCourses} />
                    <Route exact={true} path="/courseProvider" component={AdminAllCourseProvider} />
                    <Route exact={true} path="/accounting" component={AdminAllAccounting} />
                    <Route exact={true} path="/cpLecturers" component={CPAllLecturers} />
                    <Route exact={true} path="/cpLocations" component={CPAllLocations} />
                    <Route exact={true} path="/acdetails/:id/:month" component={AdminAccountingDetails} />
                    <Route exact={true} path="/cpcourses" component={CPAllCourses} />
                    <Route exact={true} path="/cpcoursedetail/:id" component={CPCourse} />
                    <Route exact={true} path="/cpprofile" component={CPProfile} />
                    <Route exact={true} path="/cpbookings/:month?" component={CPBookings} />
                </Switch>
            </HashRouter>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.tsx